<div class="attachments-panel">
  <div class="panel-title">{{ label }}</div>

  @if (hasContent) {
    <div class="attachments-scroll">
      @if (attachment) {
        <div class="attachments-row">
          <div class="file-name" [title]="attachment.fileNameOriginal">{{ attachment.fileNameOriginal }}</div>
          <div class="actions">
            <button
              type="button"
              class="btn btn-outline-secondary btn-icon"
              title="Download file"
              (click)="downloadFile(attachment)">
              <i class="fa fa-solid fa-download"></i>
            </button>
            @if (canRemoveAttachment) {
              <button
                type="button"
                class="btn btn-outline-danger btn-icon"
                title="Remove file"
                [disabled]="isRemoving"
                (click)="confirmRemoveAttachment()">
                <i class="fa fa-solid fa-trash"></i>
              </button>
            }
          </div>
        </div>
      } @else if (pendingFile) {
        <div class="attachments-row">
          <div class="file-name" [title]="pendingFile.name">
            {{ pendingFile.name }}
            <span class="pending-badge">Uploaded on save</span>
          </div>
          <div class="actions">
            @if (readonlyAttachmentsPanel == false) {
              <button
                type="button"
                class="btn btn-outline-danger btn-icon"
                title="Remove file"
                (click)="confirmRemovePendingFile()">
                <i class="fa fa-solid fa-trash"></i>
              </button>
            }
          </div>
        </div>
      }
    </div>
  } @else {
    <div class="empty-text">No attachment yet</div>
  }

  @if (canAddFile) {
    <div class="add-file">
      <input type="file" #fileInput (change)="onFileSelected($event)" class="hidden-file-input" />
      <button type="button" class="btn btn-primary" [disabled]="isUploading" (click)="fileInput.click()">
        <i class="fa fa-solid fa-plus me-1"></i> Add file
      </button>
    </div>
  }
</div>
